import { childAgeMonthConvert } from "../../../shared/utils/childAge";
import type { SearchTabDepartmentType, SearchTabQuery } from "./searchOptions";

type SearchTabRequestDepartmentType = Exclude<SearchTabDepartmentType, null>;

export type SearchTabRequestQuery = Omit<SearchTabQuery, "departmentType"> & {
  departmentTypes: SearchTabRequestDepartmentType[];
};

export function applyChildAgeRangeToQuery(query: SearchTabQuery, childAgeRange: number[]): void {
  if (!query?.childAgeRange || !Array.isArray(childAgeRange) || childAgeRange.length < 2) return;

  query.childAgeRange.gte = childAgeMonthConvert(childAgeRange[0], false);
  query.childAgeRange.lte = childAgeMonthConvert(childAgeRange[1], true);
}

export function buildSearchTabRequestQuery(query: SearchTabQuery): SearchTabRequestQuery {
  const { departmentType, ...queryWithoutDepartmentType } = query;
  return {
    ...queryWithoutDepartmentType,
    departmentTypes: departmentType ? [departmentType] : []
  };
}

export function cloneSearchTabQuery<T>(query: T): T {
  return JSON.parse(JSON.stringify(query)) as T;
}
